import { render, staticRenderFns } from "./lutPreviews.vue?vue&type=template&id=23e8deb4&"
import script from "./lutPreviews.vue?vue&type=script&lang=js&"
export * from "./lutPreviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports